import { Image, makeStyles, Text, Tooltip } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

interface IClient {
    key: string;
    name: string;
    height: number;
    width: number;
}

const clients: IClient[] = [
    {
        key: "macro",
        name: "Macro Group",
        height: 18,
        width: 100
    },
    {
        key: "hilton",
        name: "Hilton",
        height: 56,
        width: 80
    },
    {
        key: "leightons",
        name: "Leightons Opticians",
        height: 76,
        width: 100
    },
    {
        key: "woodmansterne",
        name: "Woodmansterne",
        height: 76,
        width: 100
    },
    {
        key: "tesco",
        name: "Tesco",
        height: 76,
        width: 100
    },
    {
        key: "vw",
        name: "Volkswagen Group",
        height: 76,
        width: 100
    }
];

const useStyles = makeStyles({
    contentContainer: {
        gridRow: '1 / -1',
        zIndex: 2,
        display: 'grid',
        placeItems: 'center',
        textAlign: 'center',
        padding: '2rem',
    },
    row: {
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: "2rem",
        marginBottom: "3rem",
        width: "100%"
    },
    title: {
        textTransform: "uppercase"
    },
    client: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flex: "1 1 calc(16.66% - 2rem)",
        maxWidth: "calc(16.66% - 2rem)",

        "@media (max-width: 1200px)": {
            flex: "1 1 calc(33.33% - 2rem)",
            maxWidth: "calc(33.33% - 2rem)"
        },

        "@media (max-width: 768px)": {
            flex: "1 1 calc(50% - 2rem)",
            maxWidth: "calc(50% - 2rem)"
        },

        "& img": {
            width: "auto",
            maxWidth: "100%",
            maxHeight: "100px"
        }
    }
});

const Client = (props: { client: IClient }) => {
    const { client } = props;
    const styles = useStyles();

    const imgPath = `img/home/client-logos/${client.key}.webp`;

    return (
        <div className={styles.client}>
            <Tooltip content={client.name} relationship="label">
                <Image src={imgPath} alt={client.name} width={client.width} height={client.height} />
            </Tooltip>
        </div>
    );
};

export default function Clients() {
    const { t } = useTranslation("home");
    const styles = useStyles();

    return (
        <div className={styles.contentContainer}>
            <Text as="h2" size={600} weight="semibold" align="center" className={styles.title}>
                {t("clients")}
            </Text>

            <div className={styles.row}>
                {clients.map((client) => <Client key={client.key} client={client} />)}
            </div>
        </div>
    );
}